/**
 * Form widget types
 * Defined in FormWidgetType.java
 */

export default {
	BUTTON: 'button',
	FIELD: 'field',
	RECORD_LIST: 'record-list',
	CHECKBOXES: 'checkboxes',
	TEXT: 'text',
	DASHBOARD: 'dashboard',
}